import { serialize, deserialize, plainToClass, Type, Exclude, Transform } from "class-transformer";
import { Box } from './box';
import { Board } from './board';
import moment, {Moment} from 'moment';
import gql from 'graphql-tag';

import * as SIMULATION_RESULTS_FRAGMENT_QUERY from 'src/graphql/SimulationResultsFragment.graphql';

export class Plant {
  id: number;
  name: string;
  deleted: boolean;
  newest: Plant;
  placeholder: string = null;

  static restore(ePlant: any) {
    return plainToClass<Plant, Object>(Plant, ePlant);
  }
}

export class FoodType {
  id: number;
  name: string;
  deleted: boolean;
  newest: FoodType;
  placeholder: string = null;
}

export class PackagingSystem {
  id: number;
  name: string;
  deleted: boolean;
  newest: PackagingSystem;
  placeholder: string = null;
}

export class StorageCondition {
  id: number;
  name: string;
  deleted: boolean;
  newest: StorageCondition;
  placeholder: string = null;
}

export class Threshold {
  RH_value: string;
  bct_value: number;
}

export class Project {

  id: number;
  name: string = '';
  description: string = '';
  color: string = '';

  owner: string = '';

  archived: boolean;

  simulate_carbon_footprint: boolean;
  @Type(() => Plant)
  @Transform(ePlant => Plant.restore(ePlant), { toClassOnly: true })
  plant: Plant;

  simulate_food_safety: boolean;
  food_type: FoodType;
  packaging_system: PackagingSystem;
  storage_condition: StorageCondition;
  thresholds: Threshold[] = [];

  @Transform(value => moment(value), { toClassOnly: true })
  createdAt: Moment;

  @Transform(value => moment(value), { toClassOnly: true })
  modifiedAt: Moment;

  @Type(() => Box)
  @Transform(eBox => Box.restore(eBox), { toClassOnly: true })
  box: Box = null;

  @Type(() => Board)
  @Transform(eBoard => Board.restore(eBoard), { toClassOnly: true })
  boards: Board[] = [];

  simulation_results: any[] = [];

  store(): any {
    return serialize(this);
  }

  static restore(eProject: any) {
    return plainToClass<Project, Object>(Project, eProject);
  }

  async eraseSimulationResults(apollo) {
    return apollo.mutate({
      mutation: gql`mutation ($id: Int!) {
          projectDeleteSimulationResults(id: $id)
        }
      `,
      variables: {
        id: this.id,
      },
      update: (store, {data: { projectDeleteSimulationResults }}) => {
        let data: any = store.readFragment({
          id: `Project:${this.id}`,
          fragment: SIMULATION_RESULTS_FRAGMENT_QUERY,
        });

        data.simulation_results = [];

        store.writeFragment({
          id: `Project:${this.id}`,
          fragment: SIMULATION_RESULTS_FRAGMENT_QUERY,
          data,
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        projectDeleteSimulationResults: this.id,
      },
    });
  }
}



// WEBPACK FOOTER //
// ../common/project.ts